import {
  lowQuantityError,
  notIndividualShipEligible,
  personalizationError,
} from '@/components/DeliveryOptions/util';
import { useHasMultipleDesigns, useHasPersonalization } from '@/hooks/Design';
import { useAllIndividualShipEligible } from '@/hooks/Product';
import { useHasAnySinglesQuantities } from '@/hooks/Project/useHasAnySinglesQuantities';

/**
 * Hook to determine if the project is eligible for BSS delivery method.
 */
export const useBssEligibility = () => {
  const hasMultipleDesigns = useHasMultipleDesigns();
  const hasPersonalization = useHasPersonalization();
  const hasSinglesQuantities = useHasAnySinglesQuantities();
  const [allProductsEligibleBSS, { isFetching, isLoading }] =
    useAllIndividualShipEligible();

  const isEligibleBSS =
    !hasPersonalization && !hasSinglesQuantities && allProductsEligibleBSS;

  const isSelfService = !(isEligibleBSS && hasMultipleDesigns);

  let ineligibleReason = '';
  if (isEligibleBSS) {
    ineligibleReason = '';
  } else if (!allProductsEligibleBSS) {
    ineligibleReason = notIndividualShipEligible;
  } else if (hasSinglesQuantities) {
    ineligibleReason = lowQuantityError;
  } else if (hasPersonalization) {
    ineligibleReason = personalizationError;
  }

  return [
    { isEligibleBSS, isSelfService, ineligibleReason },
    { isFetching, isLoading },
  ] as const;
};
